import PropTypes from "prop-types";
import React from 'react'


const SEO = ( {title} ) => {
    return (
        <>
            <meta charSet="utf-8" />
            <title>N01ZET Sharing is the Value</title>
            <meta name="robots" content="noindex, follow" />
            <meta name="description" content="N01ZET - Le partage est la valeur - Sharing Value Platform
Blockchain RH Epargne Entreprise Marketplace BPCE AGA Capital salariés rémunérations payroll Paie Salaires
  Employee Engagement -  Gratification – Récompenses EVP Employee Value Proposition - donations
  Employee Recognition  Engagement Salarial RH  Rewards - Employee Recognition - CSE - Saving - Cash - vouchers
  Compensation and benefits   Avantages salariaux Vouchers CSE Chèques Vacances Cadeaux Donations Marketplace to share success - rewards are benficial and lucrative" />
            <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
        </>
    )
}
SEO.propTypes = {
    title: PropTypes.string
};

export default SEO;


